import { isB2BStore, useSettings } from '@/data/Settings';
import { ProductType } from '@/data/types/Product';
import { useMemo } from 'react';
import { getStoreDataByPhysicalStoreId } from './commonIntegrationUtils';

export const getIsProductExcluded = ({
	product,
	physicalStoreId,
	isB2B,
}: {
	product: ProductType;
	physicalStoreId: string;
	isB2B: boolean;
}) => {
	const storeData = getStoreDataByPhysicalStoreId(physicalStoreId);
	if (!storeData) return false;

	const marketId = storeData.marketId;

	const ATTR_STORE_BUYABLE_EXCLUDE = isB2B ? 'PRO_STORE_BUYABLE_EXCLUDE' : 'STORE_BUYABLE_EXCLUDE';
	const ATTR_MARKET_BUYABLE_EXCLUDE = isB2B
		? 'PRO_MARKET_BUYABLE_EXCLUDE'
		: 'MARKET_BUYABLE_EXCLUDE';

	const attributes = product?.attributes ?? [];

	return attributes.some((attribute) => {
		if (attribute?.identifier === ATTR_STORE_BUYABLE_EXCLUDE) {
			return attribute?.values.some(
				(value) => value?.value && value.value.includes(physicalStoreId)
			);
		}

		if (attribute?.identifier === ATTR_MARKET_BUYABLE_EXCLUDE) {
			return attribute?.values.some((value) => value?.value && value.value.includes(marketId));
		}

		return false;
	});
};

export const useIsProductExcluded = ({
	product,
	physicalStoreId,
}: {
	product: ProductType;
	physicalStoreId: string;
}) => {
	const { settings } = useSettings();
	const isB2B = isB2BStore(settings);

	const isProductExcluded = useMemo(
		() =>
			getIsProductExcluded({
				product,
				physicalStoreId,
				isB2B,
			}),
		[isB2B, physicalStoreId, product]
	);

	return {
		isProductExcluded,
	};
};
